import { render, staticRenderFns } from "./shieldProtected.vue?vue&type=template&id=59a42357&"
import script from "./shieldProtected.vue?vue&type=script&lang=js&"
export * from "./shieldProtected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports